import { useMemo } from 'react';

import { createMinHeightSync, type MinHeightSync } from './createMinHeightSync';

export type { MinHeightSync } from './createMinHeightSync';

/**
 * Keeps a set of target elements at least as tall as one source element,
 * for example a table row's cells that must line up with a sibling cell.
 *
 * Pass `source` as the ref of the element to measure and `target` as the ref
 * of each element to size. The height is written to the targets' inline
 * `minHeight` by a ResizeObserver and never passes through React state, so a
 * list of many rows does not leave renders pending after each commit.
 */
export const useMinHeightSync = (): MinHeightSync =>
  useMemo(createMinHeightSync, []);
